import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  getFileSizeFromBase64(base64File: string) {
    return atob(base64File)?.length; //in bytes
  }

  getFileTypeFromBase64(base64File: string) {
    const signatures = {
      JVBERi0: 'application/pdf',
      R0lGODdh: 'image/gif',
      R0lGODlh: 'image/gif',
      iVBORw0KGgo: 'image/png',
      '/9j/': 'image/jpg',
    };

    return Object.entries(signatures).find(([sk, s]) => base64File?.indexOf(sk) === 0)?.[1];
  }

  getDataURLFromFile(file: File) {
    const result = new BehaviorSubject<string>(null);
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onloadend = event => result.next(<string>event.target.result);

    return result;
  }

  getDataURLFromBase64(base64: string) {
    if (!base64) return '';

    return 'data:' + this.getFileTypeFromBase64(base64) + ';base64,' + base64;
  }

  // getBase64FromImageURL(imageURL: string) {
  // const result = new BehaviorSubject<string>(null);
  // var xhr = new XMLHttpRequest();
  // xhr.onload = function () {
  //     var reader = new FileReader();
  //     reader.onloadend = () => result.next(<string>reader.result);
  //     reader.readAsDataURL(xhr.response);
  // };
  // xhr.open('GET', imageURL);
  // xhr.responseType = 'blob';
  // xhr.send();

  // return result;
  // return this.http.get(imageURL, {
  //     headers: {
  //         'Accept': '*/*',
  //         'Content-Type': '*/*'
  //     },
  //     observe: 'body',
  //     responseType: 'arraybuffer'
  // }).pipe(
  //     take(1),
  //     map(arrayBuffer =>
  //         btoa(Array.from(new Uint8Array(arrayBuffer)).map(b => String.fromCharCode(b)).join('')))
  // );
  // }

  getBase64FromDataURL(dataURL: string | ArrayBuffer) {
    if (!dataURL) return '';

    return (<string>dataURL).replace('data:', '').replace(/^.+,/, '');
  }

  // isValidHttpURL(string: string) {
  //     let url;

  //     try {
  //         url = new URL(string);
  //     } catch (_) {
  //         return false;
  //     }

  //     return url.protocol === "http:" || url.protocol === "https:";
  // }

  // getBase64(string: string): Observable<string> {
  //     return this.isValidHttpURL(string) ?
  //         this.getBase64FromImageURL(string) :
  //         of(this.getBase64FromDataURL(string));
  // }
}
